export const handleErrorActivateMarginBoost = (
  error: any,
  onError: () => void,
): void => {
  const errorMessage =
    error.response?.data?.error ||
    'An error occurred while cancelling the margin boost.';
  onError();
  console.error(errorMessage, error);
};
